module.exports = __webpack_public_path__ + "img/confusa.4b140819.png";